import { createFileRoute } from '@tanstack/react-router';

import { loadSimulationHireScreen } from '@/modules/simulation/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';

// Endereço antigo de Contratar com o rótulo do tenant (labelConfig.ts:28-45, router.tsx:1134-1225): as jornadas novas
// ficam no slug do rótulo padrão, e o link salvo é redirecionado para elas (ou para a Em construção, se não migrou).
export const Route = createFileRoute('/_app/ccb/contratar/$')({
  component: lazyScreen(loadSimulationHireScreen, 'LegacyHireRedirectRouteScreen'),
});
